import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import FormInput from '../ReactHookFormCustom/FormInput';
import { sendTestEmail } from '../../Services/applicationService';

const SendTestEmailModal = ({ showModal, closeModal, emailAddress, subject, content }) => {
  const { t } = useTranslation();
  const { handleSubmit, reset, control } = useForm({});

  const handleSubmitWithValidations = (values) => {
    sendTestEmail(values.emailAddress, subject, content);
  };

  useEffect(() => {
    reset({
      emailAddress: emailAddress,
    });
  }, [showModal]);

  return (
    <Modal isOpen={showModal} centered>
      <ModalHeader>
        <h3 className="d-flex align-items-center">
          <i className="fa icon-envelope mr-2" /> {t('email.SEND_TEST')}
        </h3>
      </ModalHeader>
      <form onSubmit={handleSubmit(handleSubmitWithValidations)}>
        <ModalBody>
          <Row className="pt-2">
            <Col>
              <FormInput
                control={control}
                name="emailAddress"
                id="emailAddressId"
                label={t('common.E_MAIL')}
                rules={{ required: t('common.REQUIRED') }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-muted text-left">{t('email.REPLACEMENT_MESSAGE')}</span>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">{t('email.SEND_TEST')}</Button>
          <Button onClick={() => closeModal()}>{t('common.CANCEL')}</Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default SendTestEmailModal;
